export default __webpack_public_path__ + "static/media/14.35a1f247.jpg";